import gql from 'graphql-tag';

export const issueUserNonce = gql`
  mutation issueUserNonce($input: IssueUserNonceInput!) {
    issueUserNonce(input: $input) {
      url
    }
  }
`;
